import axios from "axios";
import { Service } from "axios-middleware";
import user from "@/store/modules/user";
import router from "@/router/";

const service = new Service(axios);

const withAccept = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json",
    Accept: "application/json"
  }
});

const normal = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json"
  }
});

const cloudinary = axios.create({
  baseURL: process.env.CLOUDINARY_URL,
  timeout: 30000,
  headers: {}
});

service.register({
  onRequest(config) {
    if (
      config.baseURL != process.env.CLOUDINARY_URL &&
      localStorage.authentication
    )
      config.headers.Authorization = `Bearer ${localStorage.authentication}`;

    return config;
  },
  onResponseError(error) {
    if (error.response.status === 401) {
      user.dispatch("clearToken");
      router.push("/login");
    }

    throw error;
  }
});

export default {
  normal,
  withAccept,
  cloudinary
};



// WEBPACK FOOTER //
// ./src/API/HTTP.js